import { Box } from '@mui/material';

export default function DashboardLayout({ children }) {
  return <Box p={3}>{children}</Box>;
}
